import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
    return (
        <input
            type={type}
            className={cn(
                'border-input bg-card ring-offset-background file:text-foreground placeholder:text-muted-foreground flex h-10 w-full rounded-xl border px-3.5 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium',
                'focus-visible:border-primary focus-visible:ring-primary transition-colors duration-200 outline-none focus-visible:ring-1 focus-visible:ring-offset-0',
                'aria-invalid:border-destructive dark:aria-invalid:border-destructive/50',
                'aria-invalid:focus-visible:border-destructive aria-invalid:focus-visible:ring-destructive dark:aria-invalid:focus-visible:border-destructive/50 dark:aria-invalid:focus-visible:ring-destructive/50',
                'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
                className,
            )}
            ref={ref}
            {...props}
        />
    );
});
Input.displayName = 'Input';

export { Input };
